import { useQuery } from '@tanstack/react-query';
import { getDeployedLandlordRules } from 'Services';
import { RQ_DEPLOYED_LANDLORD_RULES } from 'Utils';
import { transformServerData } from 'Hooks/query-hooks/helper';
import { useTranslation } from 'react-i18next';

type UseLatestDeployProps = {
    enabled?: boolean;
};

function useDeployedLandlordRules({ enabled }: UseLatestDeployProps) {
    const { t } = useTranslation();
    return useQuery([RQ_DEPLOYED_LANDLORD_RULES], () => getDeployedLandlordRules(), {
        enabled: enabled !== false,
        select: transformServerData({ t })
    });
}

export default useDeployedLandlordRules;
